import { useMutation, useQuery } from '@tanstack/react-query'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { ActivityIndicator } from '..'
import trackEvents from '../../constants/track-events'
import { useNotificationContext, usePartnerContext } from '../../context'
import { mutation, query } from '../../graphql'
import { trackEvent } from '../../helpers/analytics'
import FlexConfiguration from '../shared/flex-configuration'

const PublicInvitationModal = ({ open, setOpen }) => {
  const { t } = useTranslation()
  const { partner: partnerContext } = usePartnerContext()
  const { success } = useNotificationContext()

  const {
    status,
    data: partner,
    refetch
  } = useQuery({
    queryKey: ['partner', partnerContext.id],
    queryFn: () =>
      query({ query: 'getPartner', variables: { id: partnerContext.id } })
  })

  const updatePartner = useMutation({
    mutationFn: (input) => mutation({ mutation: 'updatePartner', input })
  })

  const handleUpdatePartner = ({ input, onSuccess, onError }) => {
    updatePartner.mutate(input, {
      onSuccess: async () => {
        await refetch()
        success(t('career.flex.update_career_success'))
        trackEvent(trackEvents.ACTIVATE_PUBLIC_LINK_INVITATION_POOL)
        if (onSuccess) onSuccess()
      },
      onError: () => {
        if (onError) onError()
      }
    })
  }

  if (status === 'pending') {
    return (
      <div className='py-14'>
        <ActivityIndicator />
      </div>
    )
  }

  return (
    <FlexConfiguration
      open={open}
      setOpen={setOpen}
      entity={partner}
      updateHandler={handleUpdatePartner}
      type='partner'
      update
    />
  )
}

PublicInvitationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired
}

export default PublicInvitationModal
